<template>
  <div class="content">
    <div class="image-text_1 flex-row justify-between">
      <div class="box_8 flex-col"></div>
      <span class="text-group_1">人力资源</span>
      <div class="group_2 flex-col"></div>
    </div>
    <div class="cultureMain">
      <div class="section_4">
        <div class="text-wrapper_2 flex-col" :style="{'background':talentPolicyShow?'#005AD6':'#FFFFFF','border':talentPolicyShow? '':'1px solid #005AD6'}"  @click="talentPolicyDivShow()">
          <span class="text_16" :style="{'color':talentPolicyShow?'#FFFFFF':'#005AD6'}">人才政策</span>
        </div>
        <div class="text-wrapper_3 flex-col" :style="{'background':jobPostingsShow?'#005AD6':'#FFFFFF','border':jobPostingsShow? '':'1px solid #005AD6'}" @click="jobPostingsDivShow()">
          <span class="text_17" :style="{'color':jobPostingsShow?'#FFFFFF':'#005AD6'}">招聘信息</span>
        </div>
      </div>

    </div>
    <div class="section_5">
      <talentPolicy  v-if="talentPolicyShow"></talentPolicy>
      <jobPostings v-if="jobPostingsShow"></jobPostings>
    </div>
  </div>
</template>

<script>
import Pagination from './Pagination'
import talentPolicy from './talentPolicy'
import jobPostings from './jobPostings'
export default {
  components: { Pagination,talentPolicy,jobPostings },
  name: "QualificationsHonors",
  data() {
    return {
      talentPolicyShow:true,//人才政策show
      jobPostingsShow:false,//招聘信息show
    }
  },
  methods:{
    jobPostingsDivShow(){
      let that = this;
      that.talentPolicyShow=false;
      that.jobPostingsShow=true;
    },
    talentPolicyDivShow(){
      let that = this;
      that.talentPolicyShow=true;
      that.jobPostingsShow=false;
    }
  },
  mounted() {
  },
}
</script>

<style scoped>
.section_5{
  width: 1120px;
  height: auto;
  margin-top: 20px;
}
.section_4{
  width: 264px;
  height: 38px;
  display: flex;
  position: absolute;
  right: 0;
}
.text-wrapper_2 {
  background-color: rgba(0, 90, 214, 1);
  height: 38px;
  width: 120px;
  cursor: pointer;
}

.text_16 {
  width: 80px;
  height: 22px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 18px;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 22px;
  margin: 8px 0 0 20px;
}

.text-wrapper_3 {
  background-color: rgba(255, 255, 255, 1);
  height: 38px;
  border: 1px solid rgba(0, 90, 214, 1);
  margin-left: 24px;
  width: 120px;
  cursor: pointer;
}

.text_17 {
  width: 88px;
  height: 22px;
  overflow-wrap: break-word;
  color: rgba(0, 90, 214, 1);
  font-size: 18px;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 22px;
  margin: 8px 0 0 16px;
}

.content{
  width: 1120px;
  height: 100%;
  position: relative;
}

.cultureMain{
  width: 1120px;
  height: 40px;
  flex-wrap: wrap;
  margin-top: 120px;
  position: relative;
}
.image-text_1 {
  width: 141px;
  height: 48px;
  position: relative;
  top: 88px;
}
.text-group_1 {
  width: 104px;
  height: 26px;
  overflow-wrap: break-word;
  color: rgba(30, 30, 30, 1);
  font-size: 26px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
  line-height: 26px;
  margin-top: 11px;
}
.group_2 {
  width: 28px;
  height: 48px;
  background: url('../../../../assets/aboutSailHero/img/y_1.png')
  0px 0px no-repeat;
  background-size: 29px 48px;
}

.box_8 {
  width: 28px;
  height: 48px;
  background: url('../../../../assets/aboutSailHero/img/z_1.png')
  0px 0px no-repeat;
  background-size: 29px 48px;
  margin-left: 485px;
}
</style>

<style  lang="less" scoped>
/deep/ .snap-list {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  position: relative;
  left: -50px;
  .line {
    border-bottom: 1px solid rgb(36, 155, 255);
    width: 595px;
    position: absolute;
    top: 18px;
  }
  .el-timeline {
    margin-left: 650px;
    width: 595px;
    padding-left: 0px;
  }
  .timeline-icon-z {
    background: url('../../../../assets/aboutSailHero/img/z.png') no-repeat;
    background-size: 75px 18px;
    /* 设置图标的宽度和高度 */
    width: 75px;
    height: 18px;
    position: absolute;
    right: 0;
    top: 53px;
    /* 设置图标的位置 */
    background-position: center;
    /* 隐藏默认的图标 */
    background-color: transparent;
    border: none;
  }
  .timeline-icon-y {
    background: url('../../../../assets/aboutSailHero/img/y.png') no-repeat;
    background-size: 75px 18px;
    /* 设置图标的宽度和高度 */
    width: 75px;
    height: 18px;
    position: absolute;
    left: 0px;
    top: 48px;
    /* 设置图标的位置 */
    background-position: center;
    /* 隐藏默认的图标 */
    background-color: transparent;
    border: none;
  }
  .el-timeline-item {
    padding-bottom: 10px;
    .el-timeline-item__node--normal{
      display: none;
      margin-top: 45px;
    }
    .el-timeline-item__wrapper{
      padding-left: 43px;
      .el-timeline-item__content {
        color: #076EF1;
        font-size: 20px;
      }
      .el-timeline-item__timestamp {
        width: 550px;
        margin-top: 12px;
      }
      .el-timeline-item__timestamp.is-top{
        margin-bottom: -4px;
      }
    }
    .el-timeline-item__tail {
      border-left: 1px solid #005AD6;
      left: 0px;
      margin-top: 10px;
      height: 120%;
    }
    .el-timeline-item__node--large {
      width:14px;
      height: 14px;
      margin-top: 6px;
    }
  }
}
/deep/ .el-timeline-item-live-out{
  .el-timeline-item__wrapper{
    left: -595px;
  }
}
/deep/ .el-timeline-item-live-even{
  .el-timeline-item__wrapper{
    text-align: left;
  }
}
/deep/ .el-card{
  border: 0px solid #EBEEF5;
}
</style>
